import BlockchainDetails from "pages/BlockchainDetails/index.js";

export default function BlockchainDetailsPage() {
    return <BlockchainDetails />;
}
